import { render, staticRenderFns } from "./BadgeListStore.vue?vue&type=template&id=0ec98c42&"
import script from "./BadgeListStore.vue?vue&type=script&lang=js&"
export * from "./BadgeListStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec98c42')) {
      api.createRecord('0ec98c42', component.options)
    } else {
      api.reload('0ec98c42', component.options)
    }
    module.hot.accept("./BadgeListStore.vue?vue&type=template&id=0ec98c42&", function () {
      api.rerender('0ec98c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badges/BadgeListStore.vue"
export default component.exports